import AuthenticationUtil from '../../../../util/AuthenticationUtil';
import { usePrompt } from '../../../../util/PromptUtil';
import BreadCrumb from '../../../../component/BreadCrumb';
import { useNavigate } from 'react-router-dom';
import { useRef, useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import TextEditor from '../../../../component/editor/TextEditor';
import InputBox from '../../../../component/InputBox';
import DatePickerBox from '../../../../component/DatePickerBox';
import BoardPupupCheck from '../../../../component/BoardPupupCheck';
import PopupRef from '../../../../component/PopupRef';
import MultiFileAttachBox from '../../../../component/MultiFileAttachBox';
import SingleFileAttachBox from '../../../../component/SingleFileAttachBox';
import { actionAdd } from '../../../../module/body/community/notice/CommunityNoticeModule';
import { VIEW_COMMUNITY_NOTICE_ADD } from '../../../../constant/ViewConstant';
import CancelButtonBox from '../../../../component/buttons/CancelButtonBox';
import ConfirmButtonBox from '../../../../component/buttons/ConfirmButtonBox';
import { COMMUNITY_NOTICE_PATH, FILE_TYPE, ROLE } from '../../../../constant/Constant';
import CodeUtil from '../../../../util/CodeUtil';
import NullCheckUtil from '../../../../util/NullCheckUtil';

const CommunityNoticeAddView = () => {
    // const auth = AuthenticationUtil.get();
    // usePrompt('현재 페이지를 벗어나시겠습니까?', true);

    const [postingNo, setPostingNo] = useState('');
    const [postingTitleNm, setPostingTitleNm] = useState('');
    const [postingCtnt, setPostingCtnt] = useState('');
    const [noticeTypeCd, setNoticeTypeCd] = useState('');
    const [noticeBgnDt, setNoticeBgnDt] = useState('');
    const [noticeEndDt, setNoticeEndDt] = useState('');
    const [files, setFiles] = useState([]);
    const [noticeFileUid, setNoticeFileUid] = useState('');
    const [noticeFileNm, setNoticeFileNm] = useState('');
    const [addPermission, setAddPermission] = useState(false);
    const [isAdmin, setIsAdmin] = useState(false);
    const [isPopupNotice, setIsPopupNotice] = useState(false);

    const navigate = useNavigate();
    const popupRef = useRef(null);
    const dispatch = useDispatch();

    useEffect(() => {
        window.scrollTo(0,0);
        if (AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN || AuthenticationUtil.getUserRoleCd() == ROLE.STAFF) {
            setAddPermission(true);
        } else {
            popupRef.current.openAlert(
                '공지사항 등록 권한이 부족합니다. 공지사항 목록 조회 화면으로 이동합니다.',
                () => {
                    return function () {
                        navigate(COMMUNITY_NOTICE_PATH);
                    };
                },
            );
        }
        if (AuthenticationUtil.getUserRoleCd() == ROLE.ADMIN) {
            setIsAdmin(true);
        }
        setNoticeTypeCd(CodeUtil.getCodes('NOTICE_TYPE')[0].cd);
    }, []);

    useEffect(() => {
        if (noticeTypeCd == 'POP-UP') {
            setIsPopupNotice(true);
        } else if (noticeTypeCd == 'NORMAL') {
            setIsPopupNotice(false);
        }
    }, [noticeTypeCd]);

    const handleCancel = () => {
        navigate(COMMUNITY_NOTICE_PATH);
    };

    const handleConfirm = () => {
        let bgnDt = '';
        let endDt = '';
        if (noticeBgnDt) {
            bgnDt = noticeBgnDt.replace(/-/gi, '');
        }
        if (noticeEndDt) {
            endDt = noticeEndDt.replace(/-/gi, '');
        }

        if (validateNotice() && validateNoticeFile()) {
            dispatch(
                actionAdd({
                    params: {
                        postingNo,
                        postingTitleNm,
                        postingCtnt,
                        noticeTypeCd,
                        noticeBgnDt: bgnDt,
                        noticeEndDt: endDt,
                        noticeFileUid,
                        files,
                    },
                    callback: (pno) => {
                        popupRef.current.openInfo(
                            '게시물 번호 ' + pno + '이 등록되었습니다. 공지사항 목록으로 이동합니다.',
                            () => {
                                return function () {
                                    navigate(COMMUNITY_NOTICE_PATH);
                                };
                            },
                        );
                    },
                }),
            );
        }
    };

    const validateNotice = () => {
        if (!addPermission) {
            popupRef.current.openAlert('로그인하신 사용자의 권한이 부족합니다.');
            return false;
        }
        if (NullCheckUtil.isEmpty(postingTitleNm)) {
            popupRef.current.openAlert('제목을 입력해주세요.');
            return false;
        }
        if (NullCheckUtil.isEmpty(postingCtnt)) {
            popupRef.current.openAlert('내용을 입력해주세요.');
            return false;
        }
        return true;
    };

    const validateNoticeFile = () => {
        if (noticeTypeCd == 'POP-UP') {
            if (NullCheckUtil.isEmpty(noticeBgnDt)) {
                popupRef.current.openAlert('팝업게시 시작일자를 선택해주세요.');
                return false;
            }
            if (NullCheckUtil.isEmpty(noticeEndDt)) {
                popupRef.current.openAlert('팝업게시 종료일자를 선택해주세요.');
                return false;
            }
            if (NullCheckUtil.isEmpty(noticeFileUid)) {
                popupRef.current.openAlert('팝업게시 이미지를 업로드 해주세요.');
                return false;
            }

            var beginDate = new Date(noticeBgnDt);
            var endDate = new Date(noticeEndDt);
            if (beginDate > endDate) {
                popupRef.current.openAlert('시작일자는 종료일자보다 이후 일 수 없습니다. 일자를 확인해주세요.');
                return false;
            }
        } else if (noticeTypeCd == 'NORMAL') {
            setNoticeBgnDt('');
            setNoticeEndDt('');
            setNoticeFileUid('');
        }
        return true;
    };

    const uploadFileHandler = (result) => {
        setFiles((arr) => [
            ...arr,
            { fileUid: result.fileUid, fileNm: result.fileNm, regDttm: result.regDttm, noticeTypeCd: 'NOTICE' },
        ]);
    };

    const fileDeleteHandler = (files) => {
        setFiles(files);
    };

    const onChangeFile = (result) => {
        setNoticeFileUid(result.fileUid);
        setNoticeFileNm(result.fileNm);
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg04'>
                    {/* <h2 className='con-title'>공지사항</h2> */}
                    <h2 className='con-title'>{VIEW_COMMUNITY_NOTICE_ADD.title}</h2>
                    <p className='con-title-p'>{VIEW_COMMUNITY_NOTICE_ADD.subTitle}</p>
                </div>
                <div className='sub-nav-wrap'>
                    <BreadCrumb />
                </div>
                <div className='community-wrap'>
                    {/* <h3 className='cmnty-title'>공지사항 등록</h3> */}
                    <div className='cmnty-top-box'>
                        <div className='top-box-row full'>
                            <InputBox
                                title='제목'
                                placeholder='제목을 입력하세요.'
                                value={postingTitleNm}
                                onChange={(e) => setPostingTitleNm(e.target.value)}
                            />
                        </div>
                        {isAdmin && (
                            <div className='top-box-row divide'>
                                <BoardPupupCheck
                                    title='팝업으로 게시'
                                    onChecked={(e) => {
                                        e.target.checked ? setNoticeTypeCd('POP-UP') : setNoticeTypeCd('NORMAL');
                                    }}
                                />
                                {isPopupNotice && (
                                    <>
                                        <DatePickerBox
                                            title='팝업 시작일자'
                                            value={noticeBgnDt}
                                            size='large'
                                            onChange={(e) => setNoticeBgnDt(e.target.value)}
                                        />
                                        <DatePickerBox
                                            title='팝업 종료일자'
                                            value={noticeEndDt}
                                            size='large'
                                            onChange={(e) => setNoticeEndDt(e.target.value)}
                                        />
                                        <div className='w-634'>
                                            <SingleFileAttachBox
                                                labelName={'팝업이미지'}
                                                onChangeFile={(e) => onChangeFile(e)}
                                                fileUid={noticeFileUid}
                                                fileNm={noticeFileNm}
                                                editable={true}
                                                download={false}
                                                availableTypes={[
                                                    FILE_TYPE.PNG,
                                                    FILE_TYPE.JPG,
                                                    FILE_TYPE.JPEG,
                                                    FILE_TYPE.GIF,
                                                ]}
                                                fileTypeErrorMsg={
                                                    '파일형식이 맞지 않습니다. 팝업이미지는 PNG, JPG, JPEG, GIF 파일형식만 등록가능합니다.'
                                                }
                                            />
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                    <TextEditor className='cmnty-wrt-box' value={postingCtnt} onChange={setPostingCtnt} />
                    <MultiFileAttachBox
                        className='cmnty-file-box'
                        uploadFileHandler={(e) => uploadFileHandler(e)}
                        files={files}
                        editable={true}
                        erasable={true}
                        fileDeleteHandler={(e) => fileDeleteHandler(e)}
                    />
                    <div className='cmnty-btn-box btn-wrap'>
                        <CancelButtonBox title='취소' onClick={(e) => handleCancel(e)} />
                        <ConfirmButtonBox title='확인' onClick={(e) => handleConfirm(e)} />
                    </div>
                </div>
            </div>
            <PopupRef ref={popupRef} />
        </section>
    );
};

export default CommunityNoticeAddView;
